// extracted by mini-css-extract-plugin
module.exports = {"land-registration-guide":"LandRegistrationGuide_land-registration-guide__sBkdt"};